//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import search from '@/components/search/index.vue'
export default {
  data() {
    return {
      headerImg: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/beautyGuide.png'),
      headerJumpUrl: '',
      city: {
        name: '',
        code: ''
      },
      actions: [],
      showSheet: false,
      isFixed: false,
      form: {
        name: '',
        districtCode: '' // 区县code
      },
      end: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        // name: '',
        loading: false
      },
      list: []
    }
  },
  components: {
    uniLoadMore, search
  },
  onLoad (event) {
    this.cityCode = event.cityCode || ''
    this.getHeaderImg()
    this.queryData()
    // setTimeout(() => {
    //   window.addEventListener('scroll', this.handleScroll)
    // }, 500)
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.page.count) {
      this.queryData()
    }
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleClick(item) {
      uni.navigateTo({
        url: `/pages/scenicTutorials/detail?id=${item.id}`
      })
    },
    nameInput(event) {
      this.form.name = event.target.value || ''
    },
    querySearchData() {
      this.page.currentPage = 1
      this.list = []
      this.finished = false
      this.queryData()
    },
    queryData(status) {
      // 异步更新数据
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/scenicspot/queryPage',
        data: {
          ...this.form,
          ...this.page,
          cityCode: this.cityCode,
          isSelling: 0
        }
      }).then(data => {
        this.page.count = data.count
        this.list.push.apply(this.list, this.renderData(data.data))
        if (this.list.length >= this.page.count) {
          this.end = true
        }
        this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        this.page.loading = false
      })
    },
    getHeaderImg() {
      this.$ajax({
        method: 'post',
        // url: '/weChat/graphicContent/queryByNumber',
        url: '/weChat/sowing/querySowingProduct',
        data: {
          areaNumbers: 'JH-JQLB-001'
        }
      }).then(result => {
        let adv = result.data['JH-JQLB-001'] || ''
        this.headerImg = adv[0] ? this.$getImg(adv[0].imageUrl) : this.headerImg
        this.headerJumpUrl = adv[0] ? adv[0].jumpUrl : this.headerJumpUrl
      }).catch(e => {
      })
    },
    handleScroll() {
      this.$nextTick(() => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        if (document.querySelector('#search')) {
          let offsetTop = document.querySelector('#search').offsetTop
          if (scrollTop >= offsetTop) {
            this.isFixed = true
          } else {
            this.isFixed = false
          }
        }
      })
    },
    renderData(data) {
      return data.map(t => {
        return {
          ...t,
          photos: t.photoImagesUrls.split(','),
          rank: t.rank === undefined ? '' : t.rank <= 5 ? t.rank : 5
        }
      })
    }
  }
}
